"use client";
import React, { useState } from "react";
import dynamic from "next/dynamic";
import { useTranslation } from "@/src/i18n/client";
import { FmButton } from "@/ui-component";

const SelectlensModal = dynamic(() => import("./SelectlensModal"));

interface Props {
    width?: string;
}

const SelectContainer: React.FC<Props> = (props) => {
    const [isShowSelectModal, setIsShowSelectModal] = useState(false);

    const toggerSelectModal = () => {
        setIsShowSelectModal((prev) => !prev);
    };
    const { t } = useTranslation("productDetail");
    const { width } = props;
    return (
        <>
            <FmButton
                size="medium"
                onClick={toggerSelectModal}
                style={{ width: width ?? "4rem" }}
            >
                {t("productDetail:SelectLenses")}
            </FmButton>
            <SelectlensModal
                visible={isShowSelectModal}
                onClose={toggerSelectModal}
            />
        </>
    );
};

export default SelectContainer;
